
const Services = () => {
  return (
    <div className="container"> 
        <h1>Servizi</h1>
        <p>Il nostro hotel offre molti servizi gratuiti ed un ricco programma di attività extra praticabili sul territorio al fine di garantire il massimo relax all’ospite della struttura. Grazie alle aree per bambini, alla piscina e all’adiacente bar sarà possibile trascorrere la propria permanenza sull’isola capitale della cultura 2022 in piena tranquillità e senza alcun pensiero. Per chi pratica sport o è amante delle attività fisiche potrà informarsi direttamente presso la reception circa tutte le iniziative presenti sull’Isola. Durante le serate Procidane sarà possibile raggiungere qualsiasi evento, sagra o festa tramite appositi transfer privati o autobus gratuiti.</p>
    </div>
  )
}

export default Services
